/*
 * Per-device conveniences in localStorage (guide open/closed, the remembered sign-in details, a dismissed install
 * card). Never progress or scores: those live on the server. Every access is in try/catch because private mode can
 * refuse storage.
 */
const PREFIX = "gateway.";

export function readPref(key: string): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string | null): void {
  try {
    if (value === null) localStorage.removeItem(PREFIX + key);
    else localStorage.setItem(PREFIX + key, value);
  } catch {
    /* Remembered for this session at least. */
  }
}

export function readJsonPref<T>(key: string): T | null {
  const raw = readPref(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}
